import { render, staticRenderFns } from "./strategyOrder.vue?vue&type=template&id=32a215b8&scoped=true"
import script from "./strategyOrder.vue?vue&type=script&lang=js"
export * from "./strategyOrder.vue?vue&type=script&lang=js"
import style0 from "./strategyOrder.vue?vue&type=style&index=0&id=32a215b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a215b8",
  null
  
)

export default component.exports